import React, { Component, Fragment } from 'react';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import PersonaFitScoreBar from './../../../../PersonaFitScoreBar/PersonaFitScoreBar';
import PersonaFitRoles from './../../../../PersonaFitRozet/constants/PersonaFitRoles';
import Utils from './../../../../../../../utils';
import PersonaFitRoleAntagonists from './constants/PersonaFitRoleAntagonists';
import Dropdown from './../../../../../../Dropdown/Dropdown';
import ReportHelper from './../../../../../helpers/ReportHelper';

// eslint-disable-next-line css-modules/no-unused-class
import style from './style/teamroles.scss';


export default class TeamRolesAttachment extends Component {
    constructor(props) {
        super(props);

        this.switchPerspective = this.switchPerspective.bind(this);

        this.state = {
            activePerspective: 0 /* which key of PersonaFitRoles is currently active ? */
        };
    }

    getPerspectiveSelectionOptions() {
        const perspectiveSelectionOptions = [];

        Object.keys(PersonaFitRoles).forEach((perspective, index) => {
            perspectiveSelectionOptions.push(
                <option
                    value={ index }
                    key={ `perspective_${index}` }
                >
                    { this.props.i18nParticipation[`report_rozet_perspective_dropdown_${Utils.camelCaseToSnakeCase(perspective)}`] || perspective }
                </option>
            );
        });

        return perspectiveSelectionOptions;
    }

    constructScoreBar(score, active) {
        const scoreBarClass = style[ReportHelper.getIdentifierForScoreKey(score.name, PersonaFitRoles).toLowerCase()];

        return <figure key={ score.name }>
            <PersonaFitScoreBar
                outerWidth="100%"
                innerWidth={ `${score.score || 0}%` }
                height="15px"
                score={ active ? score.score || 0 : null }
                classes={{
                    root: active ? style.teamRoles__scoreBar__active : style.teamRoles__scoreBar,
                    scoreBarOutside: style.teamRoles__scoreBarOutside,
                    scoreBarInside: scoreBarClass
                }}
            />
        </figure>;
    }

    findScoreByKey(key, scores) {
        let returnScore = null;

        scores.forEach(score => {
            if (score.name === key) {
                returnScore = score;
            }
        });

        return returnScore;
    }

    switchPerspective(event) {
        this.setState({
            activePerspective: parseInt(event.target.value, 0)
        });
    }

    render() {
        const { content, personalityRozet, ambitionRozet, i18nParticipation } = this.props;

        // to ensure the scores are always parsed in the same order, first sort them alphabetically
        const preSortedScores = (Utils.alphabeticallySortFieldInArray(content.scores, 'name'));

        const sortedScores = (Utils.numericallySortFieldInArray(preSortedScores, 'score')).reverse();
        const activePerspective = Object.keys(PersonaFitRoles)[this.state.activePerspective];
        const output = [];

        // iterate over the score collection, sorted by score value
        sortedScores.forEach((score, index) => {

            const identifier = ReportHelper.getIdentifierForScoreKey(score.name, PersonaFitRoles);

            // only deal with scores that belong to the active perspective (ToBe / ToWant)
            if (PersonaFitRoles[activePerspective][identifier]) {
                const label = i18nParticipation[`report_rozet_${identifier.toLowerCase()}`] || ReportHelper.getIdentifierForScoreKey(score.name, PersonaFitRoles).toLowerCase();

                output.push(<li key={ index }>
                    <header key={ label } className={ style.teamRolesScoreRow__header }>{ label }</header>
                    <ul className={ style.teamRoles__scoreRow }>
                        <li>
                            { /* add score as scoreBar */ }
                            { this.constructScoreBar(score, true) }

                            { /* determine the score antagonist using lookup table and add it too, as a scoreBar */ }
                            { this.constructScoreBar(this.findScoreByKey(PersonaFitRoleAntagonists[score.name], sortedScores), false) }
                        </li>
                        <li>
                            { /* show default role definition */ }
                            <p>{ i18nParticipation[`report_rozet_role_definition_${identifier.toLowerCase()}`] }</p>
                        </li>
                    </ul>
                </li>);
            }
        });

        return <Fragment>
            <div className={ style.teamRoles }>

                { content.definition
                    ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                        <p dangerouslySetInnerHTML={{ __html: content.definition }}/>
                    </SectionBlock>
                    : null
                }

                <div className={ style.teamRoles__rozetList }>
                    <ul>
                        <li
                            className={ activePerspective === 'ToWant' ? style.teamRolesRozet__inactive : style.teamRolesRozet }
                            onClick={ () => {
                                if (activePerspective === 'ToWant') {
                                    this.setState({ activePerspective: 0 });
                                }
                            }}
                        >
                            { personalityRozet }
                        </li>
                        <li
                            className={ activePerspective === 'ToBe' ? style.teamRolesRozet__inactive : style.teamRolesRozet }
                            onClick={ () => {
                                if (activePerspective === 'ToBe') {
                                    this.setState({ activePerspective: 1 });
                                }
                            }}
                        >
                            { ambitionRozet }
                        </li>
                    </ul>
                </div>

                <div className={ style.teamRoles__dropdown__container }>
                    <Dropdown
                        title={ i18nParticipation.report_rozet_perspective_dropdown_sorted_by }
                        onChange={ event => {
                            this.switchPerspective(event);
                        }}
                        value={ this.state.activePerspective }
                        classes={{
                            root: style.teamRoles__dropdown,
                            optionSelection: style.teamRoles__optionSelection
                        }}
                    >
                        { this.getPerspectiveSelectionOptions() }
                    </Dropdown>
                </div>

                <div className={ style.teamRoles__scoreList }>
                    <ul>
                        { output }
                    </ul>
                </div>

            </div>
        </Fragment>;
    }
}
